export default "__VITE_ASSET__BzBd3DD4__"